import type { UserRetailAccount } from '@shared/types';
import { useRetailAccounts as useRetailAccountsQuery } from '../queries/retailAccounts';

export function hasActivePortfolio(accounts: UserRetailAccount[]): boolean {
  // oxlint-disable-next-line unicorn/no-useless-length-check -- explicit for readability
  return accounts.length > 0 && accounts.some((a) => a.active);
}

export function useRetailAccounts(options?: { enabled?: boolean }) {
  const { data: accounts = [], isLoading: loading, error } = useRetailAccountsQuery(options);

  const errorMessage = error
    ? ((error as { response?: { data?: { error?: string } } }).response?.data?.error ??
      'Failed to load accounts')
    : null;

  return {
    accounts,
    loading,
    error: errorMessage,
    hasActivePortfolio: hasActivePortfolio(accounts),
  };
}
